import { Clock } from "lucide-react";

/**
 * RegisterSoonButton — a register-style button that shows a "Coming Soon"
 * label on hover and does not navigate. Keeps visual continuity with the
 * existing CTAs across the site.
 */
export function RegisterSoonButton({
  label = "Register",
  icon: Icon = null,
  className = "",
  testid = "register-soon",
}) {
  return (
    <button
      type="button"
      data-testid={testid}
      aria-disabled="true"
      className={`group relative inline-flex items-center gap-2 cursor-not-allowed select-none ${className}`}
    >
      {/* Default state */}
      <span className="inline-flex items-center gap-2 transition-opacity duration-200 group-hover:opacity-0">
        {label}
        {Icon ? <Icon size={16} /> : null}
      </span>
      {/* Hover state (Coming Soon) */}
      <span className="absolute inset-0 flex items-center justify-center gap-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100 pointer-events-none">
        <Clock size={14} />
        Coming soon
      </span>
    </button>
  );
}
